import { useRouter } from "next/router";
import Llm from "./Llm";
import Chart from "./Chart";
import DetailPortfolio from "../Portfolio/Index";
import { useDetailAI } from "utils/clientAPIs/detailAI";
import useSVG from "utils/clientAPIs/detailSvg";
import React, { useEffect, useState } from "react";
import { AiSectionSkeleton } from "components/skeleton/detail";
import TotalLevel from "./TotalLevel";
import PriceForecast from "./Forecast";
import { CRYPTO } from "utils/constant/ITME_INFO";
import DebateGeniusIndex from "./DebateGenius/Index";
import DetailTab from "./Tab";
import DebateGeniusSummary from "./DebateGenius/Summary";
import Fundamental from "./ValueScouter/Fundamental";
import CorpInfo from "./ValueScouter/CorpInfo";
import DiagnosisIndex from "./Diagnosis/Index";
import RequestDataTemp from "./RequestDataTemp";
import DetailAIFeedIndex from "./FeedIndex";
import DetailAINewsRaderSummary from "./NewLader/Summary";
import DetailFundamentalSummary from "./ValueScouter/FundamentalSummary";
import { TYPO } from "styles/Typo";
export const Skeleton = () => {
  return (
    <div className="w-full">
      <AiSectionSkeleton />
    </div>
  );
};

function AI({
  detailData,
  toggleActive,
  type,
  setType,
  riskTargetDate,
  prevDayData,
  isNoPortUser,
  isValidScoreStock,
  isHalt,
  scoreData,
  setPriceForecastExplainModal,
  isHoliday,
  isMobile,
  isLoginUser,
  orderCategory,
  aiData,
}: {
  detailData: any;
  toggleActive: any;
  type: any;
  setType: any;
  riskTargetDate: any;
  prevDayData: any;
  isNoPortUser: any;
  isValidScoreStock: boolean;
  isHalt: boolean;
  scoreData?: any;
  isHoliday?: boolean;
  setPriceForecastExplainModal: any;
  isMobile: boolean;
  isLoginUser?: boolean;
  orderCategory?: any;
  aiData?: any;
}) {
  const [svgData, isSvgValid] = useSVG({ ticker: detailData?.ITEM_CD });
  const router = useRouter();
  const [alarmAnimationInit, setAlarmAnimationInit] = useState(false);
  if (detailData?.CAT === CRYPTO) {
    return (
      <div className="">
        <PriceForecast
          setPriceForecastExplainModal={setPriceForecastExplainModal}
          detailData={detailData}
          riskTargetDate={riskTargetDate}
          CAT={detailData?.CAT}
          LOC={detailData?.LOC}
          isHoliday={isHoliday}
        />
        <Chart detailData={detailData} svgData={svgData} delayed={true} />
      </div>
    );
  }

  if (isValidScoreStock) {
    return (
      <div>
        <Chart detailData={detailData} svgData={svgData} />
      </div>
    );
  }
  // 한국/미국 종목(stock)
  return (
    <div>
      <DetailTab isMobile={isMobile} totalPercent={scoreData?.TOTAL_PER} />
      <div className="detail-tab-content">
        {!router.query?.tab || router.query?.tab === "overview" ? (
          <>
            <RequestDataTemp
              isDisplay={
                (!scoreData?.TOTAL_PER &&
                  String(scoreData?.TOTAL_PER) !== "0") ||
                !aiData?.itemProfileData ||
                !aiData?.itemProfileData?.business_summary ||
                !aiData?.momentumExplainData ||
                aiData?.momentumExplainData?.length === 0
              }
              subTitle="아직 없는 정보가 궁금하시다면"
              title="분석을 요청해주세요"
              buttonText="요청하기"
              dataGtmId={"sDetail-data-request-button"}
              ticker={detailData?.ITEM_CD_DL}
              url={"/api/detail/requestdata"}
              clickHandler={() => {}}
            />
            <TotalLevel detailData={detailData} scoreData={scoreData} />
            {/* GEO: overview 기본 HTML 에 business_summary 가 반드시 들어가도록
                (CorpInfo 는 ?tab=info 에만 있어 크롤러가 못 읽음) */}
            {aiData?.itemProfileData?.business_summary && (
              <div className="px-6 pt-[30px] flex flex-col gap-2">
                <h3 className={`${TYPO.TYPO4_SB} text-gray90`}>기업 개요</h3>
                <p
                  className={`${TYPO.TYPO7_1_RG} text-gray70`}
                  style={{
                    wordWrap: "break-word",
                    wordBreak: "keep-all",
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                  }}
                >
                  {aiData.itemProfileData.business_summary}
                </p>
              </div>
            )}
            {/* <DebateGeniusSummary isMobile={isMobile} /> */}
            <DetailAINewsRaderSummary detailData={detailData} />
            <DetailFundamentalSummary
              data={aiData?.momentumExplainData}
              ticker={detailData?.ITEM_CD_DL}
            />
            {!isHalt && (
              <PriceForecast
                setPriceForecastExplainModal={setPriceForecastExplainModal}
                detailData={detailData}
                riskTargetDate={riskTargetDate}
                CAT={detailData?.CAT}
                isHoliday={isHoliday}
                LOC={detailData?.LOC}
              />
            )}
            <Chart detailData={detailData} svgData={svgData} delayed={true} />
          </>
        ) : router.query?.tab === "score" ? (
          <DiagnosisIndex
            scoreData={scoreData}
            detailData={detailData}
            alarmAnimationInit={alarmAnimationInit}
            setAlarmAnimationInit={setAlarmAnimationInit}
          />
        ) : router.query?.tab === "info" ? (
          <div>
            <Fundamental momentumExplainData={aiData?.momentumExplainData} />
            <CorpInfo itemProfileData={aiData?.itemProfileData} />
          </div>
        ) : (
          <DetailAIFeedIndex detailData={detailData} />
        )}
      </div>
    </div>
  );
}

const DetailAI = React.memo(AI);
export default DetailAI;
